import type {
  FilterFunc,
  FilterState,
  FilterType,
} from "@/components/controls/grid/columnfilters/ColumnFilters";
import { buildApplyFilter } from "@/components/controls/grid/columnfilters/ColumnFilters";
import { LocalDate } from "@js-joda/core";

function isLocalDate(toTest: any): toTest is LocalDate {
  return (toTest as LocalDate)?.chronology !== undefined;
}

export const dateFilterTypes: FilterType[] = [
  {
    type: "filter_equals",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: any) => {
      return filterValue
        ? isLocalDate(itemValue) &&
            itemValue.isEqual(LocalDate.parse(filterValue))
        : true;
    },
  },
  {
    type: "filter_not_equals",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: any) => {
      return filterValue
        ? isLocalDate(itemValue) &&
            !itemValue.isEqual(LocalDate.parse(filterValue))
        : true;
    },
  },
  {
    type: "filter_after",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: any) => {
      return filterValue
        ? isLocalDate(itemValue) &&
            itemValue.isAfter(LocalDate.parse(filterValue))
        : true;
    },
  },
  {
    type: "filter_before",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: any) => {
      return filterValue
        ? isLocalDate(itemValue) &&
            itemValue.isBefore(LocalDate.parse(filterValue))
        : true;
    },
  },
];

export function buildApplyDateFilter(state: FilterState): FilterFunc {
  return buildApplyFilter(state, dateFilterTypes);
}
